// extracted by mini-css-extract-plugin
module.exports = {"AnnouncementSection":"Announcement_AnnouncementSection__Dn5j_","AnnouncementLayout":"Announcement_AnnouncementLayout__tlXHp","Announcement":"Announcement_Announcement__Q_vBC"};